export const ROUTE_DEFAULT = '/';
export const ROUTE_CAMPAIGN = '/campaign';
export const ROUTE_PRODUCTOS = '/products';
export const ROUTE_INSURANCE = '/insurance/:insurance';
export const ROUTE_CHALLENGE = '/challenge';
